<template>
  <VueFinalModal
    v-model="showModal"
    :esc-to-close="true"
    class="modal-container"
    content-class="modal-content"
  >
    <div class="modal__content">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p style="text-align: center; font-weight: bold; margin: 0px">
            Datos del usuario
          </p>

          <p class="p_text">
            <span class="textLabel">Usuario: </span>{{ displayName }}
          </p>

          <p class="p_text"><span class="textLabel">DNI: </span>{{ dni }}</p>

          <p class="p_text">
            <span class="textLabel">Contacto: </span>{{ contact }}
          </p>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <hr class="horizontal dark" />
          <p style="text-align: center; font-weight: bold; margin: 0px">
            Datos bancarios
          </p>

          <p class="p_text"><span class="textLabel">Banco: </span>{{ bank }}</p>

          <p class="p_text">
            <span class="textLabel">Nro. cuenta: </span>{{ numberaccount }}
          </p>

          <p class="p_text"><span class="textLabel">Tipo: </span>{{ type }}</p>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <hr class="horizontal dark" />
          <p style="text-align: center; font-weight: bold; margin: 0px">
            Datos de transacción
          </p>

          <p class="p_text"><span class="textLabel">Fecha: </span>{{ date }}</p>

          <p class="p_text">
            <span class="textLabel">Referencia: </span>{{ ref }}
          </p>

          <p class="p_text">
            <span class="textLabel">Monto a transferir: </span>$
            {{ transferAmount }}
          </p>
        </div>
      </div>
    </div>
  </VueFinalModal>

  <div class="card" style="margin-bottom: 10px">
    <div class="card-body">
      <div class="row">
        <div class="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-list"></i> Retiros pagados
          </p>
        </div>

        <div
          class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"
          align="center"
          style="display: flex"
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else @click="refresh">
            <i
              style="cursor: pointer; margin: auto"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
        </div>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else-if="notAllow" class="row">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          align="center"
        >
          <img style="width: 100px" src="/img/caution.svg" />

          <p style="margin-top: 10px; font-size: 14px">
            Tu rol no te permite utilizar la siguiente funcionalidad.
          </p>
        </div>
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="paymentRequests"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Fecha/Hora</th>
            <th data-priority="1">Usuario</th>
            <th>DNI</th>
            <th>Contacto</th>
            <th>Monto</th>
            <th>Referencia</th>
            <th data-priority="2">Acción</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import $ from "jquery";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";

DataTable.use(DataTablesCore);

export default {
  components: {
    DataTable,
    VueFinalModal,
  },
  props: ["tokenAuth"],
  data() {
    return {
      loading: true,
      showModal: false,
      paymentRequests: [],
      notAllow: false,
      displayName: "",
      dni: "",
      contact: "",
      bank: "",
      numberaccount: "",
      type: "",
      date: "",
      ref: "",
      transferAmount: "",
      columns: [
        { data: "dateFormatted" },
        { data: "user.displayName" },
        { data: "user.dni" },
        { data: "user.phone" },
        {
          data: null,
          render: function (data) {
            return `$${(data.balance ?? 0).toFixed(2)}`;
          },
        },
        {
          data: null,
          render: function (data) {
            return data.ref ?? "—";
          },
        },
        {
          data: null,
          orderable: false,
          render: function (data) {
            return `<button
              data-transferamount="${(data.balance ?? 0).toFixed(2)}"
              data-date="${data.dateFormatted ?? ""}"
              data-ref="${data.ref ?? ""}"
              data-type="${data.bank?.type ?? ""}"
              data-displayname="${data.bank?.bankUserName ?? data.user?.displayName ?? ""}"
              data-bank="${data.bank?.bank ?? ""}"
              data-numberaccount="${data.bank?.numberAccount ?? ""}"
              data-contact="${data.bank?.bankUserEmail ?? data.user?.email ?? ""}"
              data-dni="${data.bank?.bankUserDni ?? data.user?.dni ?? ""}"
              class="btn btn-outline-primary btn-sm verDatosPaid"
              type="button"
            >
              <i class="fas fa-eye me-1"></i> Ver datos
            </button>`;
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [7, 15, 25, 35, 50, -1],
          [7, 15, 25, 35, 50, "All"],
        ],
        pageLength: 7,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Ingrese algún dato",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
    };
  },
  mounted() {
    this.getListado();
    $(document).off("click", ".verDatosPaid");
    $(document).on("click", ".verDatosPaid", (evt) => {
      const $btn = $(evt.currentTarget);
      this.showDatos(
        $btn.data("displayname"),
        $btn.data("dni"),
        $btn.data("contact"),
        $btn.data("bank"),
        $btn.data("numberaccount"),
        $btn.data("type"),
        $btn.data("date"),
        $btn.data("ref"),
        $btn.data("transferamount")
      );
    });
  },
  methods: {
    showDatos(
      displayName,
      dni,
      contact,
      bank,
      numberaccount,
      type,
      date,
      ref,
      transferAmount
    ) {
      this.showModal = true;
      this.displayName = displayName ?? "";
      this.dni = dni ?? "";
      this.contact = contact ?? "";
      this.bank = bank ?? "";
      this.numberaccount = numberaccount ?? "";
      this.type = type ?? "";
      this.date = date ?? "";
      this.ref = ref ?? "";
      this.transferAmount = transferAmount ?? "";
    },
    refresh() {
      this.getListado();
    },
    getListado() {
      this.loading = true;
      const session = localStorage.getItem("session");
      this.$https
        .post("/balance/loadPaidPaymentRequest/", {
          tokenAuth: this.tokenAuth,
          session,
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.loading = false;
            this.paymentRequests = response.data.paymentRequestList;
          } else {
            this.loading = false;
            this.paymentRequests = [];
          }
        })
        .catch((error) => {
          this.loading = false;
          this.paymentRequests = [];
          if (error?.data?.code == 401) {
            localStorage.removeItem("userData");
            this.$store.state.user = "";
            this.$router.push({ name: "Signin" });
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";
</style>

